module.exports = __webpack_public_path__ + "assets/img/broad-page.33afa75e.jpg";